import { dataAppsSettings } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAppsSettings = /*#__PURE__*/createIcon(dataAppsSettings)
export default IconAppsSettings
